<div
  class="account-balances-container"
  [class.account-balances-container-wide]="isFullWidth"
  [class.no-bottom-offset]="noBottomOffset"
  [class.account-balances-container-vertical]="isVerticalOrientation"
>
  <div class="account-balances-header">
    <div class="account-balances-title">{{ label }}</div>
  </div>

  <div class="account-balances">
    <div class="balance-items">
      @for (item of accountBalances; track item.type) {
        <ng-container
          *ngTemplateOutlet="
            balanceItem;
            context: { $implicit: item, value: $safeNavigationMigration(accountBalanceValues?.[item.type]), isLoading }
          "
        ></ng-container>
      }
    </div>

    @if (pendingBalances.length > 0) {
      <div class="balance-items balance-pending-items">
        @for (item of pendingBalances; track item.type) {
          <ng-container
            *ngTemplateOutlet="
              balanceItem;
              context: {
                $implicit: item,
                value: $safeNavigationMigration(accountBalanceValues?.[item.type]),
                isLoading,
                isPendingBalance: true,
              }
            "
          ></ng-container>
        }
      </div>
    }
  </div>
</div>

<ng-template #balanceItem let-item let-value="value" let-isLoading="isLoading" let-isPendingBalance="isPendingBalance">
  <div class="account-balances-item" [class.primary]="item.isPrimary" [class.loading]="isLoading">
    @if (!isLoading) {
      <div class="label">
        {{ item.label }}
        <div class="label-tooltip"><rkt-icon name="info" [title]="item.tooltip"></rkt-icon></div>
      </div>
      @if (available) {
        <div class="value">
          @if (item.icon) {
            <span class="value-icon" [ngClass]="'value-icon-' + item.icon"></span>
          }
          <div class="account-balance">
            {{ (value ? (isPendingBalance ? (value | abs) : value) : '0.00') | amount: selectedCurrency }}
          </div>
        </div>
      }
      @if (!available) {
        <div class="value not-available">N/A</div>
      }
    } @else {
      <div class="label">
        <div class="loading-placeholder" [class.dark-bg]="isPendingBalance"></div>
      </div>
      <div class="value">
        <div class="loading-placeholder" [class.dark-bg]="isPendingBalance"></div>
      </div>
    }
  </div>
</ng-template>
